import { TemplateBlock } from 'concepts/Extraction/Blocks/BaseBlock';
import {
  DomainBlock,
  newDomainBlock,
} from 'concepts/Extraction/Blocks/Domain/DomainBlock';
import {
  newTextFieldBlock,
  TextFieldBlock,
} from 'concepts/Extraction/Blocks/TextField/TextFieldBlock';
import { ExtractionFormType } from 'concepts/Extraction/ExtractionFormType';
import { hydrateBlock } from 'concepts/Extraction/ViewModel/TemplateViewModel';

// The editor always keeps at least one block, since the Add menu is rendered on a block

export function newBlankDomainBlock(): DomainBlock {
  return newDomainBlock('');
}

export function newBlankTextFieldBlock(): TextFieldBlock {
  return hydrateBlock(newTextFieldBlock('')) as TextFieldBlock;
}

export function newBlankBlock(formType: ExtractionFormType): TemplateBlock {
  return formType === 'quality_assessment'
    ? newBlankDomainBlock()
    : newBlankTextFieldBlock();
}
